import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnInit,
} from "@angular/core";

@Component({
  selector: "icn-color-picker",
  templateUrl: "./color-picker.component.html",
  styleUrls: ["./color-picker.component.scss"],
})
export class ColorPickerComponent implements OnInit {
  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  @Input()
  value: string;

  @Output()
  valueChange = new EventEmitter<string>();

  selected = false;

  onToggleChanged(isShown) {
    this.changeDetectorRef.markForCheck();
    this.selected = isShown;
  }

  onColorPickerChange(newColor) {
    this.value = newColor;
    this.valueChange.emit(newColor);
  }

  toRgba(hex8) {
    const r = parseInt(hex8.substring(1, 3), 16);
    const g = parseInt(hex8.substring(3, 5), 16);
    const b = parseInt(hex8.substring(5, 7), 16);
    const a = parseInt(hex8.substring(7, 9), 16) || 100;

    return `rgba(${r},${g},${b},${a / 100})`;
  }

  ngOnInit(): void {
    console.log("color-picker-> value ", this.value);
    this.changeDetectorRef.detectChanges();
  }
}
